import { render } from "./App.vue?vue&type=template&id=34d8cd30&lang=pug"
const script = {}

import "./App.vue?vue&type=style&index=0&id=34d8cd30&lang=sass"
script.render = render

export default script